<template>
  <div>
    <div class="row g-4">
      <!-- ====== Departments Loop ====== -->
      <div
        v-for="department in departments"
        :key="department.name"
        class="col-12"
      >
        <div class="card p-4">
          <!-- Department Title -->
          <div class="fw-bold mb-3">{{ department.name }}</div>

          <!-- Timeline Header -->
          <div class="small text-uppercase text-muted mb-2">
            Planning Timeline
          </div>

          <div class="timeline-header">
            <div></div>
            <div>Priority</div>
            <div
              v-for="n in department.timelineDays"
              :key="department.name + '-header-' + n"
              class="text-center"
            >
              {{ n }}
            </div>
          </div>

          <!-- Tasks -->
          <div
            v-for="task in department.tasks"
            :key="task.name"
            class="gantt-row"
          >
            <div>{{ task.name }}</div>

            <div>
              <span class="badge" :class="task.priorityColor">
                {{ task.priority }}
              </span>
            </div>

            <div
              class="plan-bar"
              :class="task.planColor"
              :style="{
                gridColumn: task.planStart + ' / span ' + task.planDuration,
                width: '100%',
              }"
            ></div>

            <div
              class="actual-bar"
              :class="task.actualColor"
              :style="{
                gridColumn: task.actualStart + ' / span ' + task.actualDuration,
                width: '100%',
              }"
            ></div>
          </div>

          <!-- Heatmaps -->
          <div class="small text-uppercase text-muted mt-3">Daily Tracking</div>

          <div
            v-for="user in department.users"
            :key="user.name"
            class="user-heatmap row"
          >
            <div class="fw-bold col-2">{{ user.name }}</div>

            <div
              class="heatmap-grid col-10"
              :style="{
                gridTemplateColumns:
                  'repeat(' + department.timelineDays + ',1fr)',
              }"
            >
              <div
                v-for="(value, index) in user.data"
                :key="user.name + '-' + index"
                class="heat-cell"
                :class="'level-' + value"
              >
                <div class="day-label">{{ index + 1 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ====== END Departments Loop ====== -->
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div class="nature-white-box">
          <div class="white-box-top"></div>
          <div class="row">
            <TopBar
              v-model:selectAll="selectAll"
              v-model:line-options="lineOptions"
              v-model:rows="rows"
              v-model:items="items"
              v-model:selectedLineOption="selectedLineOption"
              v-model:selectedItems="selectedItems"
              v-on:addNewRow="$refs.addModal.showModal()"
              v-on:delete="deleteBucket"
              path="work::buckets"
              :methods="listOptions"
              :show-languages="false"
              :show-currencies="false"
            />
            <DynamicTable
              v-model:rows="rows"
              v-model:items="items"
              v-model:select-all="selectAll"
              v-on:update:val="valUpdated"
              :show-pin="false"
              v-on:selected="(e) => (selectedItems = e)"
              type="buckets"
              v-on:loadMore="loadMore"
              v-on:order="orderBy"
              :order="order"
              :fix-height="true"
              :key="tableKey"
            />
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      ref="multipleEditModal"
      :title="`Edit ${selectedItems.length} operations`"
      :text="`<p>You will edit<b> ${selectedItems.length}</b> operations</p>
 <p>You will edit all selected rows.</p>`"
      cancel-button="Modify only edited row"
      :ok-button="`Edit selected ${selectedItems.length} rows`"
      v-on:success="multipleEdit"
    />
    <NewBucket ref="addModal" v-on:add="addNewRow" :statuses="statuses" />
  </div>
</template>

<script>
import DynamicTable from "@/components/lists/DynamicTable";
import TopBar from "@/components/lists/TopBar";
import { useStore } from "vuex";
import ws from "@/modules/ws";
import http from "@/modules/http";
import lineOptions from "@/modules/lineOptions";
import ConfirmModal from "../../../components/modals/ConfirmModal";
import NewBucket from "../../../components/modals/NewBucket.vue";

export default {
  name: "Operations",
  components: {
    NewBucket,
    ConfirmModal,
    DynamicTable,
    TopBar,
  },
  created() {},
  data() {
    return {
      store: useStore(),
      tableKey: 0,
      rows: [],
      filtersTimeOut: null,
      selectedLineOption: 0,
      lineOptions: [],
      selectAll: false,
      items: [],
      statuses: [],
      selectedItems: [],
      selectedEditMethod: {},
      page: 1,
      newCustomRowValue: undefined,
      listOptions: [],
      order: {
        row: null,
        desc: true,
      },

      departments: [
        {
          name: "Development",
          health: 78,
          healthColor: "bg-success",
          timelineDays: 28,

          tasks: [
            {
              name: "Checkout API",
              priority: "High",
              priorityColor: "bg-danger",
              planStart: 3,
              planDuration: 8,
              planColor: "bg-primary",
              actualStart: 3,
              actualDuration: 5,
              actualColor: "bg-success",
            },
          ],

          users: [
            { name: "John", data: [] },
            { name: "Sarah", data: [] },
          ],
        },

        {
          name: "Marketing",
          health: 52,
          healthColor: "bg-warning",
          timelineDays: 28,

          tasks: [
            {
              name: "SEO Optimization",
              priority: "High",
              priorityColor: "bg-danger",
              planStart: 3,
              planDuration: 6,
              planColor: "bg-success",
              actualStart: 3,
              actualDuration: 4,
              actualColor: "bg-primary",
            },
          ],

          users: [
            { name: "Emma", data: [] },
            { name: "Lucas", data: [] },
          ],
        },
      ],
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    path() {
      return this.$route.path;
    },
    sessionId() {
      return this.store.state.sessionId;
    },
    filters() {
      return this.store.state.filters?.buckets;
    },
  },
  mounted() {
    this.$store.commit("setFilterPage", "buckets");
    this.loadData();

    ws.init();

    ws.subscribe("add", "buckets", (e) => {
      if (e.session !== this.sessionId) {
        this.items.push(e.object);
        this.tableKey++;
      }
    });

    ws.subscribe("modify", "buckets", (e) => {
      let obj = this.items[this.items.findIndex((o) => o.id === e.objectId)];
      if (obj !== undefined) {
        if (e.session !== this.sessionId) {
          obj[e.rowKey] = e.value;
        }
      }
    });
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.filtersTimeOut !== null) {
          clearTimeout(this.filtersTimeOut);
        }
        this.filtersTimeOut = setTimeout(() => {
          this.filtersTimeOut = null;
          this.items = undefined;
          this.page = 1;
          this.loadData();
        }, 300);
      },
    },
  },
  methods: {
    generateHeatmaps() {
      const generateUserData = (days) =>
        Array.from({ length: days }, () =>
          Math.min(4, Math.floor(Math.random() * 6))
        );

      this.departments.forEach((dept) => {
        dept.users.forEach((user) => {
          user.data = generateUserData(dept.timelineDays);
        });
      });
    },
    orderBy(order) {
      this.items = undefined;
      this.page = 1;
      this.order = order;
      this.loadData();
    },
    loadMore() {
      console.log("No more page yet");
      // this.page++;
      // this.loadData();
    },
    addNewRow(row) {
      row.selected = this.selectAll;
      if (this.selectAll) {
        this.selectAllDiff++;
      }
      this.items.unshift(row);
      this.tableKey++;
    },
    loadData() {
      let url = `/work/buckets?page=${this.page}&order[desc]=${
        this.order.desc ? 1 : 0
      }&order[row]=${this.order.row ? this.order.row : ""}`;

      if (Object.keys(this.filters).length > 0) {
        for (const filter in this.filters) {
          if (Array.isArray(this.filters[filter].value)) {
            for (const value of this.filters[filter].value) {
              url += `&filter[${filter}][]=${value}`;
            }
          } else {
            url += `&filter[${filter}]=${this.filters[filter].value}`;
          }
        }
      }
      http.fetch(url).then((data) => {
        this.generateHeatmaps();
        if (this.page === 1) {
          if (this.rows.length === 0) {
            this.rows = lineOptions.init(data.rows, data.line_options);
            this.lineOptions = data.line_options;
            this.selectedLineOption = data.line_options[0]?.id;
          }
          this.statuses = data.statuses;
          this.items = data.data;
          this.tableKey++;
        } else {
          for (const row of data.data) {
            this.items.push(row);
          }
        }
      });
    },
    valUpdated(val, row, id, item) {
      if (this.selectedItems.length > 1) {
        this.$refs.multipleEditModal.showModal();
        this.selectedEditMethod = {
          val: val,
          row: row,
          id: id,
          item: item,
        };
      }
      this.editItems(val, row, id, item);
    },
    multipleEdit() {
      this.editItems(
        this.selectedEditMethod.val,
        this.selectedEditMethod.row,
        this.selectedItems.map((e) => e.id),
        this.selectedEditMethod.item
      );
    },
    editItems(val, row, id, item) {
      let data = { rows: id };
      data[row] = val;

      if (typeof val === "object" && val.length === 0) {
        val.push({ id: 0 });
      }

      if (val === 0 && this.newCustomRowValue === undefined) {
        return;
      }

      if (val === 0 && this.newCustomRowValue !== undefined) {
        data[row] = this.newCustomRowValue;
        data.add = 1;
        this.newCustomRowValue = undefined;
      }

      if (row === "cost") {
        data["cost"] = val.amount;
        data["cost_currency_code"] = val.currency;
      }

      http.fetch(`/work/buckets`, data, true, "PUT").then((respond) => {
        if (data.add) {
          let rowData = this.rows.filter((e) => e.key === row)[0];
          rowData.values.push({ id: respond.id, name: data[row] });
          item[row] = respond.id;
          this.newCustomRowValue = undefined;
        }
      });
    },
    deleteBucket() {
      let data = [];
      for (const item of this.selectedItems) {
        data.push(item.id);
      }
      http.fetch(`/work/buckets`, { rows: data }, true, "DELETE").then(() => {
        for (const item of this.selectedItems) {
          let i = this.items.indexOf(item);
          if (i > -1) {
            this.items.splice(i, 1);
          }
        }
        this.tableKey++;
      });
    },
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

.timeline-header {
  display: grid;
  grid-template-columns: 180px 80px repeat(28, 1fr);
  font-size: 0.7rem;
  color: #9ca3af;
  margin-bottom: 10px;
}

.gantt-row {
  display: grid;
  grid-template-columns: 180px 80px repeat(28, 1fr);
  align-items: center;
  margin-bottom: 12px;
  position: relative;
}

.plan-bar {
  position: absolute;
  height: 18px;
  border-radius: 10px;
  opacity: 0.35;
  top: 50%;
  transform: translateY(-50%);
}

.actual-bar {
  position: absolute;
  height: 12px;
  border-radius: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.user-heatmap {
  margin-top: 12px;
}

.heatmap-grid {
  display: grid;
  grid-template-columns: repeat(28, 1fr);
  gap: 4px;
}

.heat-cell {
  padding-top: 100%;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  transition: 0.2s;
}

.heat-cell:hover {
  transform: scale(1.1);
}

.level-0 {
  background: #e5e7eb;
}
.level-1 {
  background: #bfdbfe;
}
.level-2 {
  background: #60a5fa;
}
.level-3 {
  background: #2563eb;
}
.level-4 {
  background: #1e3a8a;
}

.day-label {
  position: absolute;
  top: 3px;
  left: 4px;
  font-size: 0.55rem;
}
</style>
